/* eslint-disable import/no-cycle */
import { combineReducers } from '@reduxjs/toolkit';

import commonModule from 'modules/commonModule';
import mastersModule from 'modules/mastersModule';

const rootReducer = combineReducers({
  common: commonModule.reducer,
  masters: mastersModule.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
